module.exports = __webpack_public_path__ + "img/down_new_title.b76a1114.png";